module.exports = __webpack_public_path__ + "media/old_images/image-promo-water-02-8616aaa9.jpg";